import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import type { Group } from '@libs/src/models/group.model';
import type { PathwayPopulated } from '@libs/src/models/pathway.interface';
import type { ProgramTemplate } from '@libs/src/models/program-template.model';

const v2GroupsAPI = (groupId: string) => `/api/v2/groups/${groupId}`;
const getV2Url = (groupId: string) =>
  `${v2GroupsAPI(groupId)}/program-templates`;

@Injectable({ providedIn: 'root' })
export class ProgramTemplatesBackend {
  constructor(private readonly http: HttpClient) {}

  v2 = {
    createProgramTemplate: (
      groupId: Group['_id'],
      programTemplate: ProgramTemplate,
    ) =>
      this.http.post<{ programTemplate: ProgramTemplate }>(getV2Url(groupId), {
        programTemplate,
      }),
    deleteProgramTemplatePathway: (
      groupId: Group['_id'],
      templateId: ProgramTemplate['_id'],
      pathwayId: PathwayPopulated['_id'],
    ) =>
      this.http.delete<{ programTemplate: ProgramTemplate }>(
        `${getV2Url(groupId)}/${templateId}/pathways/${pathwayId}`,
      ),
    getProgramTemplate: (groupId: string, programTemplateId: string) =>
      this.http.get<{ programTemplate: ProgramTemplate }>(
        `${getV2Url(groupId)}/${programTemplateId}`,
      ),
    listProgramTemplates: (
      groupId: string,
      params: { limit: string; skip: string } = { limit: '50', skip: '0' },
    ) =>
      this.http.get<{
        programTemplates: ProgramTemplate[];
        totalCount: number;
      }>(getV2Url(groupId), { params }),
    patchProgramTemplate: (
      groupId: string,
      templateId: string,
      programTemplate: ProgramTemplate,
    ) =>
      this.http.patch<{ programTemplate: ProgramTemplate }>(
        `${getV2Url(groupId)}/${templateId}`,
        {
          programTemplate,
        },
      ),
    patchProgramTemplatePathway: (
      groupId: Group['_id'],
      templateId: ProgramTemplate['_id'],
      pathwayId: PathwayPopulated['_id'],
    ) =>
      this.http.patch<{ programTemplate: ProgramTemplate }>(
        `${getV2Url(groupId)}/${templateId}/pathways/${pathwayId}`,
        {},
      ),
  };
}
